import {
  updateShowDropAreaDeactivationOverlay,
  updateShowMachineStructureDropAreaDeactivationOverlay,
} from "@src/reducers/your-reducer";
import store from "@src/reducers/store";

export const deactivateAllAreaOverlays = () => {
  store.dispatch(updateShowDropAreaDeactivationOverlay(false));
  store.dispatch(updateShowMachineStructureDropAreaDeactivationOverlay(false));
};
